// Copyright (c) 2021 WiseTime. All rights reserved.

import { RpcError } from "grpc-web"
import { getLoginPath } from "../app/routing"

// type-guard for grpc-web RpcError type
export const isGrpcError = (e: unknown): e is RpcError => {
  if (e === undefined) {
    return false
  }

  const grpcError = e as RpcError
  return "code" in grpcError && "message" in grpcError && "metadata" in grpcError
}

export const redirectToLogin = (): void => window.location.replace(getLoginPath())
